import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { rentalCarTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';
const CarRentalTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const vehicleOption = checkboxData.rentalVehicle;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const durationOption = checkboxData.carsRentalDuration;
    const purposeOption = checkboxData.carsPurpose;
    const driveTypeOption = checkboxData.driveType;

    const formik = useFormik({
        initialValues: {
            price: Math.floor(merchant?.price * currency.value) || '',
            vehicle: merchant?.vehicle || [],
            areaOfWorking: merchant?.areaOfWorking || [],
            workingSince: merchant?.workingSince || [],
            duration: merchant?.duration || [],
            purpose: merchant?.purpose || [],
            driveType: merchant?.driveType || [],
        },
        enableReinitialize: true,
        validationSchema: rentalCarTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, price: Math.floor(values.price * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Type of Vehicle</th>
                                                            <th style={{ width: '25%' }}>Serving Cities</th>
                                                            <th style={{ width: '25%' }}>Rental Duration</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>
                                                            <td>{
                                                                merchant.vehicle
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.duration
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>




                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>

                                                            <th>Purpose</th>
                                                            <th>Drive Type</th>
                                                            <th>price</th>


                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.purpose
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td>{
                                                                merchant.driveType
                                                                    ?.map((item, index) => {
                                                                        return (<span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>)
                                                                    })
                                                            }</td>

                                                            <td><NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.price
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            /></td>

                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>

                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Type of Vehicle <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={vehicleOption}
                                                            selected
                                                            value={formik.values.vehicle}
                                                            onChange={(vehicle) => formik.setFieldValue('vehicle', vehicle)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.outdoorBudget ? (
                                                            <div className="text-danger">{formik.errors.outdoorBudget}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Serving Cities</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>


                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Rental Duration</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={durationOption}
                                                            selected
                                                            value={formik.values.duration}
                                                            onChange={(duration) => formik.setFieldValue('duration', duration)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.duration && formik.errors.duration ? (
                                                            <div className="text-danger">{formik.errors.duration}</div>
                                                        ) : null}
                                                    </div>
                                                </div>




                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Purpose</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={purposeOption}
                                                            selected
                                                            value={formik.values.purpose}
                                                            onChange={(purpose) => formik.setFieldValue('purpose', purpose)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.purpose && formik.errors.purpose ? (
                                                            <div className="text-danger">{formik.errors.purpose}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Drive Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={driveTypeOption}
                                                            selected
                                                            value={formik.values.driveType}
                                                            onChange={(driveType) => formik.setFieldValue('driveType', driveType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.driveType && formik.errors.driveType ? (
                                                            <div className="text-danger">{formik.errors.driveType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Price</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="price"
                                                            placeholder='Starting Price'
                                                            value={formik.values.price}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.price && formik.errors.price ? (
                                                        <div className="text-danger">{formik.errors.price}</div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CarRentalTTK